import { AxiosError, AxiosResponse } from 'axios'
import { useMutation } from 'react-query'

import * as requests from './requests'
import { ResponseError } from '../../types'

export const useOnboardingMutation = () =>
  useMutation<AxiosResponse, AxiosError<ResponseError>>(requests.onboarding)
